import { ReactNode } from 'react'
import { cn } from '@/lib/utils'
import { Breadcrumb, BreadcrumbItem } from '../primitives/Breadcrumb'
import { CommonPageLayout } from './CommonPageLayout'

interface ListPageLayoutProps {
  children: ReactNode
  className?: string
}

interface ListPageLayoutHeaderProps {
  /**
   * Breadcrumb items for navigation
   */
  breadcrumbItems: BreadcrumbItem[]
  /**
   * Icon to display in breadcrumb
   */
  breadcrumbIcon?: ReactNode
  /**
   * Additional header content (title, filters, etc.)
   */
  children?: ReactNode
  className?: string
}

interface ListPageLayoutContentProps {
  children: ReactNode
  className?: string
}

function ListPageLayoutRoot({ children, className }: ListPageLayoutProps) {
  return <CommonPageLayout className={className}>{children}</CommonPageLayout>
}

function ListPageLayoutHeader({
  breadcrumbItems,
  breadcrumbIcon,
  children,
  className,
}: ListPageLayoutHeaderProps) {
  return (
    <div className={cn('mb-4 flex-shrink-0 space-y-3', className)}>
      <Breadcrumb icon={breadcrumbIcon} items={breadcrumbItems} />
      {children}
    </div>
  )
}

function ListPageLayoutContent({
  children,
  className,
}: ListPageLayoutContentProps) {
  return (
    <div className={cn('mt-3 flex flex-1 flex-col overflow-hidden', className)}>
      {children}
    </div>
  )
}

export const ListPageLayout = Object.assign(ListPageLayoutRoot, {
  Header: ListPageLayoutHeader,
  Content: ListPageLayoutContent,
})
